// extracted by mini-css-extract-plugin
module.exports = {"block":"BrowserBlock-module--block--37MJS"};